import _Promise from 'babel-runtime/core-js/promise';
import { withServiceImplementation } from '@myaccount/utils';
import { ModalTypes } from './modalsTypes';

import IModals from './ModalsInterface';

export default withServiceImplementation(IModals, {
  open: function open(props) {
    return function (modal) {
      props.onOpen(modal);
      return _Promise.resolve('[IModals] open success');
    };
  },

  openWithdraw: function openWithdraw(props) {
    return function () {
      props.onOpen(ModalTypes.WITHDRAW);
      return _Promise.resolve('[IModals] open withdraw success');
    };
  },

  openWithdrawAccountVerification: function openWithdrawAccountVerification(props) {
    return function () {
      props.onOpen(ModalTypes.WITHDRAW_ACCOUNT_VERIFICATION);
      return _Promise.resolve('[IModals] open withdrawAccountVerification (Italy) success');
    };
  },

  openReversalWithdraw: function openReversalWithdraw(props) {
    return function () {
      props.onOpen(ModalTypes.REVERSAL_WITHDRAW);
      return _Promise.resolve('[IModals] open reversal withdraw success');
    };
  },

  openGamblingControls: function openGamblingControls(props) {
    return function () {
      props.onOpen(ModalTypes.GAMBLING_CONTROLS);
      return _Promise.resolve('[IModals] open gambling controls success');
    };
  },

  openPokerBalanceTransfer: function openPokerBalanceTransfer(props) {
    return function () {
      props.onOpen(ModalTypes.POKER_BALANCE_TRANSFER);
      return _Promise.resolve('[IModals] open poker balance transfer success');
    };
  },

  close: function close(props) {
    return function () {
      props.onClose();
      return _Promise.resolve('[IModals] close success');
    };
  }
});